/* Collapsible product description.

   Shopify rejects a <div> inside a text block setting, so there is no wrapper to hook
   onto. Horizon renders the description block as an <rte-formatter> whose class carries
   the block key from templates/product.json, which gives a stable target:

     text-block--<hash>__text_aEtTtq rte
*/
(function () {
  var SELECTOR = '[class*="__text_aEtTtq"]';
  var CHEVRON =
    '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
    '<path d="M2 4.5 6 8.5l4-4" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup() {
    var block = document.querySelector(SELECTOR);
    if (!block) return;
    if (block.closest('.cs-desc')) return;

    var root = document.createElement('div');
    root.className = 'cs-desc';
    block.parentNode.insertBefore(root, block);

    var body = document.createElement('div');
    body.className = 'cs-desc__body';
    body.appendChild(block);
    root.appendChild(body);

    var limit = parseInt(getComputedStyle(root).getPropertyValue('--cs-desc-max'), 10) || 280;

    // Only collapse when it hides a meaningful amount. Short copy is left alone.
    if (body.scrollHeight <= limit + 80) return;

    root.dataset.csCollapsed = 'true';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cs-desc__toggle';
    btn.setAttribute('aria-expanded', 'false');
    body.id = 'cs-desc-body-' + Math.random().toString(36).slice(2, 8);
    btn.setAttribute('aria-controls', body.id);
    btn.innerHTML = '<span>Read more</span>' + CHEVRON;

    btn.addEventListener('click', function () {
      var collapsed = root.dataset.csCollapsed === 'true';
      root.dataset.csCollapsed = collapsed ? 'false' : 'true';
      btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      btn.querySelector('span').textContent = collapsed ? 'Read less' : 'Read more';
      // Collapsing from far down the page would otherwise strand the reader.
      if (!collapsed && root.getBoundingClientRect().top < 0) {
        root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });

    root.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', setup);
})();
